"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var model_1 = require("./model");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var abstract_destruction_subject_1 = require("../../abstract-destruction-subject");
require("./hierarchical-drillDown.component.scss");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var lodash_1 = require("lodash");
var util_1 = require("util");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var utilities_1 = require("../../utilities");
var logger = utilities_1.createLogger('hierarchical-drillDown');
var HierarchicalDrillDownComponent = /** @class */ (function (_super) {
    __extends(HierarchicalDrillDownComponent, _super);
    function HierarchicalDrillDownComponent(classifierService, kbService) {
        var _this = _super.call(this) || this;
        _this.classifierService = classifierService;
        _this.kbService = kbService;
        _this.validations = [];
        _this.valueChange = new core_1.EventEmitter();
        _this.validationEmitter = new core_1.EventEmitter();
        _this.classifierItems = new Map();
        _this.isReady = false;
        _this.levelChange$ = new BehaviorSubject_1.BehaviorSubject(null);
        _this.levelChangeSubscription();
        return _this;
    }
    HierarchicalDrillDownComponent.prototype.ngOnInit = function () {
        this.initHierarchicalComponent();
    };
    HierarchicalDrillDownComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.levelChange$) {
            this.levelChange$.complete();
        }
    };
    HierarchicalDrillDownComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['selectedItemCategories'] &&
            changes['selectedItemFields']) {
            var selectedItemCategoriesPrevious = changes['selectedItemCategories'].previousValue;
            var selectedItemFieldsPrevious = changes['selectedItemFields'].previousValue;
            if (selectedItemCategoriesPrevious !== undefined &&
                selectedItemFieldsPrevious !== undefined) {
                this.selectedItemFields =
                    changes['selectedItemFields'].currentValue;
                this.selectedItemCategories =
                    changes['selectedItemCategories'].currentValue;
                this.initHierarchicalComponent();
            }
        }
        if (this.validations && this.validations.length > 0) {
            if (this.validations.findIndex(function (validation) {
                return validation
                    .getRelatedMetaFieldIds()
                    .some(function (metaFieldId) {
                    return _this.selectedItemFields.indexOf(metaFieldId.getSystemName()) !== -1;
                });
            }) !== -1) {
                this.validationEmitter.emit();
            }
        }
    };
    HierarchicalDrillDownComponent.prototype.translateMultilingual = function (multilingual, defaultValue) {
        if (defaultValue === void 0) { defaultValue = ''; }
        if (lodash_1.isNil(multilingual)) {
            return defaultValue;
        }
        if (util_1.isString(multilingual)) {
            return multilingual + '';
        }
        if (lodash_1.isNil(this.currentLanguageId)) {
            logger.error("Current language is " + this.currentLanguageId);
            return defaultValue;
        }
        else if (multilingual instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            return multilingual.getValue(this.currentLanguageId);
        }
        else if (skynet_store_utilities_1.notNil(multilingual[this.currentLanguageId])) {
            return multilingual[this.currentLanguageId];
        }
        else {
            return defaultValue;
        }
    };
    HierarchicalDrillDownComponent.prototype.trackByFunc = function (index, item) {
        return item && item.value ? item.value.getId() : undefined;
    };
    /**
     * Initializes Hierarchical drillDown component
     */
    HierarchicalDrillDownComponent.prototype.initHierarchicalComponent = function () {
        var _this = this;
        this.getMetaCategories()
            .pipe(operators_1.mergeMap(function (metaCategories) {
            _this.hierarchicalItems = _this.initHierarchicalItems(metaCategories);
            return _this.initClassifierItems();
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    HierarchicalDrillDownComponent.prototype.getMetaCategories = function () {
        var _this = this;
        var metaCategoryIds = this.selectedItemCategories.map(function (category) { return new idm_kb_service_client_js_1.MetaCategoryId(category); });
        var metaCategories$ = [];
        metaCategoryIds.forEach(function (metaCategoryId) {
            metaCategories$.push(_this.kbService.getMetaCategoryByMetaCategoryId(metaCategoryId));
        });
        return zip_1.zip.apply(void 0, metaCategories$);
    };
    /**
     * Initializes Hierarchical Items by given metaCategories
     * @param {Array<MetaCategory>} metaCategories
     * @returns {HierarchicalDrillDownItems}
     */
    HierarchicalDrillDownComponent.prototype.initHierarchicalItems = function (metaCategories) {
        var _this = this;
        var classifier = null;
        var hierarchicalItemsData = metaCategories.map(function (metaCategory, index) {
            classifier = null;
            if (_this.entity &&
                _this.entity.getProperty(_this.selectedItemFields[index]).value !== null) {
                classifier = _this.entity.getProperty(_this.selectedItemFields[index]).value;
            }
            var metaFiledId = _this.requiredMetaFields.find(function (metaFieldId) {
                return metaFieldId.getSystemName() ===
                    _this.selectedItemFields[index];
            });
            var isRequired = metaFiledId !== undefined && metaFiledId !== null;
            return new model_1.HierarchicalDrillDownItem(classifier, metaCategory, _this.selectedItemFields[index], isRequired);
        });
        return new model_1.HierarchicalDrillDownItems(hierarchicalItemsData);
    };
    /**
     * Initializes Classifier Items map
     * @returns {Observable<Array<ClassifierView>>}
     */
    HierarchicalDrillDownComponent.prototype.initClassifierItems = function () {
        var _this = this;
        var observables = [];
        var classifiers$;
        var previousHierarchicalItem = null;
        this.hierarchicalItems.data.forEach(function (hierarchicalItem, index) {
            if (index === 0) {
                classifiers$ = _this.classifierService
                    .loadAllClassifiers(hierarchicalItem.metaCategory.getSystemName())
                    .pipe(operators_1.map(function (classifiersResponse) {
                    if (classifiersResponse &&
                        classifiersResponse.getData()) {
                        _this.classifierItems.set(hierarchicalItem.metaCategory.getSystemName(), classifiersResponse.getData());
                        return classifiersResponse.getData();
                    }
                    return [];
                }));
            }
            else if (previousHierarchicalItem.value === null) {
                _this.classifierItems.set(hierarchicalItem.metaCategory.getSystemName(), []);
                classifiers$ = of_1.of([]);
            }
            else {
                classifiers$ = _this.classifierService
                    .loadClassifiersByParent(hierarchicalItem.metaCategory.getSystemName(), previousHierarchicalItem.value.getId())
                    .pipe(operators_1.map(function (classifiersResponse) {
                    if (classifiersResponse &&
                        classifiersResponse.getData()) {
                        _this.classifierItems.set(hierarchicalItem.metaCategory.getSystemName(), classifiersResponse.getData());
                        return classifiersResponse.getData();
                    }
                    return [];
                }));
            }
            previousHierarchicalItem = hierarchicalItem;
            observables.push(classifiers$);
        });
        return zip_1.zip.apply(void 0, observables);
    };
    HierarchicalDrillDownComponent.prototype.levelChangeSubscription = function () {
        var _this = this;
        var data;
        this.levelChange$
            .pipe(operators_1.mergeMap(function (levelChangeData) {
            if (levelChangeData !== null) {
                data = levelChangeData;
                if (data.id !== null && data.id !== undefined) {
                    return _this.classifierService.loadClassifiersByParent(data.nextItemMetaCategorySystemName, data.id);
                }
            }
            return of_1.of(null);
        }))
            .subscribe(function (classifiersResponse) {
            if (data &&
                data.nextItemMetaCategorySystemName &&
                classifiersResponse) {
                _this.classifierItems.set(data.nextItemMetaCategorySystemName, classifiersResponse.getData());
            }
        }, function (err) { return console.error(err); });
    };
    /**
     * On Hierarchical component Level change action
     * @param {number} selectedValueId
     * @param {HierarchicalDrillDownItem} currentHierarchicalItem
     */
    HierarchicalDrillDownComponent.prototype.onLevelChange = function (selectedValueId, currentHierarchicalItem) {
        var selectedValue = null;
        if (this.entity &&
            this.isClassifierChanged(selectedValueId, currentHierarchicalItem)) {
            this.onValueChangeEmit(selectedValueId, currentHierarchicalItem);
            if (selectedValueId !== null) {
                selectedValue = this.classifierItems
                    .get(currentHierarchicalItem.metaCategory.getSystemName())
                    .find(function (classifier) {
                    return classifier.getId() === selectedValueId;
                });
            }
            this.entity.getProperty(currentHierarchicalItem.metaFieldName).value = selectedValue;
            currentHierarchicalItem.value = selectedValue;
            var nextHierarchicalItem = this.hierarchicalItems.getNextItem(currentHierarchicalItem);
            //reset child classifiers values
            if (nextHierarchicalItem !== undefined) {
                this.resetChildClassifiers(nextHierarchicalItem);
            }
            //Load next classifier items
            if (nextHierarchicalItem !== undefined &&
                nextHierarchicalItem !== null) {
                var data = {
                    id: selectedValueId,
                    nextItemMetaCategorySystemName: nextHierarchicalItem.metaCategory.getSystemName(),
                };
                this.levelChange$.next(data);
            }
        }
    };
    HierarchicalDrillDownComponent.prototype.onValueChangeEmit = function (selectedValueId, currentHierarchicalItem) {
        var hierarchicalItem = currentHierarchicalItem;
        if (!selectedValueId) {
            hierarchicalItem = this.hierarchicalItems.getPreviousItem(currentHierarchicalItem);
        }
        var lastLevelClassifierData = null;
        if (hierarchicalItem) {
            lastLevelClassifierData = {
                categoryName: hierarchicalItem.metaCategory.getSystemName(),
                metaFieldName: hierarchicalItem.metaFieldName,
                value: selectedValueId
                    ? selectedValueId
                    : hierarchicalItem.value.getId(),
            };
        }
        this.valueChange.emit(lastLevelClassifierData);
    };
    HierarchicalDrillDownComponent.prototype.isClassifierChanged = function (selectedValueId, currentHierarchicalItem) {
        var classifier = this.entity.getProperty(currentHierarchicalItem.metaFieldName).value;
        if (classifier === null && selectedValueId === null) {
            return false;
        }
        else if (classifier && classifier.getId() === selectedValueId) {
            return false;
        }
        else {
            return true;
        }
    };
    HierarchicalDrillDownComponent.prototype.resetChildClassifiers = function (hierarchicalItem) {
        this.entity.getProperty(hierarchicalItem.metaFieldName).value = null;
        hierarchicalItem.value = null;
        this.classifierItems.set(hierarchicalItem.metaCategory.getSystemName(), []);
        var nextHierarchicalItem = this.hierarchicalItems.getNextItem(hierarchicalItem);
        if (nextHierarchicalItem) {
            this.resetChildClassifiers(nextHierarchicalItem);
        }
    };
    HierarchicalDrillDownComponent.prototype.getFxFlex = function () {
        switch (this.density) {
            case 'loose': {
                return 50;
            }
            case 'default': {
                return 33;
            }
            case 'compact': {
                return 25;
            }
            default: {
                return 100;
            }
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalDrillDownComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HierarchicalDrillDownComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalDrillDownComponent.prototype, "validations", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalDrillDownComponent.prototype, "requiredMetaFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalDrillDownComponent.prototype, "selectedItemCategories", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalDrillDownComponent.prototype, "selectedItemFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalDrillDownComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalDrillDownComponent.prototype, "density", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalDrillDownComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], HierarchicalDrillDownComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HierarchicalDrillDownComponent.prototype, "validationEmitter", void 0);
    HierarchicalDrillDownComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'hierarchical-drillDown',
            template: require('./hierarchical-drillDown.component.html'),
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_kb_service_client_js_1.KbService])
    ], HierarchicalDrillDownComponent);
    return HierarchicalDrillDownComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HierarchicalDrillDownComponent = HierarchicalDrillDownComponent;
//# sourceMappingURL=hierarchical-drillDown.component.js.map